module.exports = __webpack_public_path__ + "static/media/image-placeholder.864a9ca2.svg";